/** @jsx jsx */
import { jsx, css } from '@emotion/core';

import React from 'react';

import { Theme } from 'features/Theme';
import { Box, Card, CardContent, Grow } from '@material-ui/core';

interface PropTypes {
  open: boolean;
  popperId: string;
  children: React.ReactNode;
  width: number;
}

const styles = {
  disclosureBox: (theme: Theme) =>
    css`
      &.disclosureBox {
        display: Flex;
      }

      &.disclosureBox.hidden {
        display: None;
      }
    `,
};

const Popover: React.FC<PropTypes> = props => {
  const { open, popperId, children, width } = props;

  return (
    <Box
      id={popperId}
      css={styles.disclosureBox}
      className={`disclosureBox ${open ? '' : 'hidden'}`}
      aria-hidden={false}
    >
      <Grow in={open}>
        <Card
          data-testid={`cardTest-${popperId}`}
          css={{
            width: width,
          }}
        >
          <CardContent>{children}</CardContent>
        </Card>
      </Grow>
    </Box>
  );
};

export default Popover;
